const gameCategories =[
    "Men's Single",
    "Women's Single",
    "Men's Double",
    "Women's Double",
    "Men's Single",
    "Mixed Double",
]
export default gameCategories;